/*jshint esversion: 9 */
import { mapGetters, mapActions } from 'vuex';

import TFlex from '@/components/Taktify/TFlex.component.vue';
import TText from '@/components/Taktify/TText.component.vue';
import StandardFlexBox from '@/components/StandardComponents/StandardFlexBox.component.vue'
import colors from 'vuetify/lib/util/colors';

export const TrainTaktareaDetailsMixin = {
  components: {
    TFlex,
    TText,
    StandardFlexBox
    },
  data: () => ({

  }),
  computed: {
    location(){
      if (this.$route.name.includes('ProjectWallet')) {
        return 'ProjectWallet';
      } else {
        return 'TaktPlan';
      }
    },
    project(){
      return this.getUObject({type:'projects', id: this.$route.params.project_id});
    },
    train(){
      return this.getUObject({type:'trains', id: this.$route.params.train_id});
    },
    taktarea(){
      return this.getUObject({type:'taktareas', id: this.$route.params.taktarea_id});
    },
    waggons(){
      return this.getUObjects({type:'twaggons', ids: this.taktarea.twaggons});
    },
    current_takt_index(){
      let index = this.getCurrentTaktIndex(this.$route.params.project_id) - (this.train.train_start + this.taktarea.taktarea_start);
      return index;
    },
    takt_index(){
      let takt_index = this.$route.params.takt_index;
      if(this.$route.params.selected_column === 'left'){
        takt_index--;
      } else if(this.$route.params.selected_column === 'right'){
        takt_index++;
      }
      return takt_index;
    },
    takt_offset(){
      if(this.$route.params.selected_column === 'left'){
        return +1;
      } else if(this.$route.params.selected_column === 'right'){
        return -1;
      }
      return 0;
    },
    ...mapGetters('ProjectCalendar', [
      'getCurrentTaktIndex',
    ]),
    ...mapGetters('Ultra', [
      'getUObjects',
      'getUObject'
    ]),
    ...mapGetters('View', [
      'getUseOnSite',
    ]),
  },
  methods: {
    ...mapActions('Ultra', [
      'requestUObject',
      'createUObject',
      'updateUObject',
      'deleteUObject',
      'updateUObjectPosition',
    ]),
    ...mapActions('WorkPackageLogList', [
      'createLogListComment',
    ]),
    calc_fg_hex(color) {
      let textcolor = color;
      if (textcolor.includes('black')) {
        return '#000'
      } else if (textcolor.includes('white')) {
        return '#FFF'
      } else {
        return colors[textcolor];
      }
    },
  }
};
